var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEthereum(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 16,
    viewBox: "0 0 10 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ethereum 2",
    clipPath: "url(#clip0_1670_14)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.24746 8.15577L4.80473 10.9396L0.35907 8.15577L4.80473 0.332367L9.24746 8.15577ZM4.80473 11.8335L0.35907 9.04971L4.80473 15.6912L9.25038 9.04971L4.80473 11.8335Z",
    fill: "#00AC4F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1670_14"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9.35928,
    height: 15.3588,
    fill: "white",
    transform: "translate(0.125 0.332336)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthereum);
export default __webpack_public_path__ + "static/media/ethereum.66aa50d32bafb087f12a0fbbf1e75b63.svg";
export { ForwardRef as ReactComponent };